export class FacilityBillingShiftDifferential {
    id: number;
    shiftType: number;
    facilityBillingRateId: number;
    name: string;
    allHours: number;
    hours8: number;
    hours10: number;
    hours12: number;
    day: boolean;
    mid: boolean;
    night: boolean;
    splitedHours: boolean;
    weekendDay: boolean;
    weekendMid: boolean;
    weekendNight: boolean;
    createdDate: Date;
    modifiedDate: Date;
}
